/* eslint-disable eqeqeq */
import React, { useEffect, useMemo, useState, useRef } from "react";
import axios from "axios";
import {
  Button,
  Col,
  Card,
  Row,
  Form,
  Tooltip,
  InputGroup,
  OverlayTrigger,
  Modal,
  Badge,
  Dropdown,
} from "react-bootstrap";
import {
  faPlus,
  faExclamationCircle,
  faRefresh,
  faShare,
  faPalette,
  faCheck,
  faExternalLinkAlt,
  faSave,
  faTimes,
  faTabletScreenButton,
  faFilePen,
  faDesktop,
  faFileText,
  faCog,
  faStream,
  faUserSecret,
} from "@fortawesome/free-solid-svg-icons";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import Select from "react-select";
import { Link, useLocation } from "react-router-dom";
import { openHelpCenter } from "./help/helpCenterEvents.js";
import InputMask from "react-input-mask";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  statusX,
  layoutX,
  getReactivationDates,
  handlePreviewSuccess,
  FormCompositionCard,
  FooterFormComponent,
  BackgroundFormComponent,
} from "./EventsComponents.js";
import PopoverPicker from "./PopoverPicker.js";
import { ApplicationsList } from "./Applications.js";
import DropzoneComponent from "./Dropzone.js";
import { domainConfig } from "../config.js";
import { ColumnSortingTable } from "./Table.js";
import { format, parse, isValid } from "date-fns";
import Datetime from "react-datetime";
import useAuth from "../hooks/useAuth.js";
import useAppSelector from "../hooks/useAppSelector.js";
import Loader from "./Loader.js";
import { confirmAlert } from "react-confirm-alert";
import { ShowConfirm } from "./Alerts.js";
import {
  redirectURL,
  HelpTooltip,
  handleFileUpload,
  generateExcelTemplate,
  getFirstError,
  safeJsonParse,
  convertDateToDisplay,
  isFutureDate,
  isRegistrationOpen,
  handleSocialShare,
  getContrastColor,
} from "../assets/functions.js";
import { selectEvents } from "../redux/slices/events.js";
import ImportValidationReportModal from "./ImportValidationReportModal.js";
import EventWebappPreview from "./EventWebappPreview.js";
import { getPlatform1ShareUrls } from "../utils/eventShareUrls.js";

const pwaMaskableImageTooltip = "Use um PNG quadrado de 512x512 com o elemento principal centralizado e margem de respiro. Esse arquivo pode ser recortado pelo sistema ao instalar o app.";
const ogImageTooltip = "Use uma imagem de 1200x630 para compartilhamento em WhatsApp, LinkedIn, Facebook e outras redes. Evite textos muito pequenos e mantenha o conteúdo principal centralizado.";
const metaTagTitleTooltip = "Título exibido no compartilhamento do link e usado por mecanismos de busca. Prefira um texto curto, claro e com o nome da plataforma ou evento.";
const metaTagDescriptionTooltip = "Resumo do link exibido nas redes sociais e buscadores. Prefira uma descrição objetiva, com contexto suficiente para incentivar o clique.";

const MetaTagFields = ({
  titleName,
  titleValue,
  titleTouched,
  titleError,
  descriptionName,
  descriptionValue,
  descriptionTouched,
  descriptionError,
  handleChange,
}) => {
  return (
    <Row className="mx-0 mb-3">
      <Form.Group as={Col} md="12" className="mb-3">
        <Form.Label>
          Título da Meta Tag
          <OverlayTrigger overlay={<Tooltip>{metaTagTitleTooltip}</Tooltip>}>
            <span className="ms-1 d-inline-block">
              <HelpTooltip icon={faExclamationCircle} />
            </span>
          </OverlayTrigger>
        </Form.Label>
        <Form.Control
          type="text"
          name={titleName}
          value={titleValue || ""}
          onChange={handleChange}
          maxLength={150}
          isInvalid={!!titleError}
          isValid={titleTouched && !titleError}
        />
        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
        <Form.Control.Feedback type="invalid">
          {titleError}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group as={Col} md="12" className="mb-3">
        <Form.Label>
          Descrição da Meta Tag
          <OverlayTrigger
            overlay={<Tooltip>{metaTagDescriptionTooltip}</Tooltip>}
          >
            <span className="ms-1 d-inline-block">
              <HelpTooltip icon={faExclamationCircle} />
            </span>
          </OverlayTrigger>
        </Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          name={descriptionName}
          value={descriptionValue || ""}
          onChange={handleChange}
          maxLength={255}
          isInvalid={!!descriptionError}
          isValid={descriptionTouched && !descriptionError}
        />
        <Form.Text className="text-muted">
          Opcional. Esses campos são usados pelo novo sistema de PWA e metatags.
        </Form.Text>
        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
        <Form.Control.Feedback type="invalid">
          {descriptionError}
        </Form.Control.Feedback>
      </Form.Group>
    </Row>
  );
};

const appModals = {
  1: [{ id: 1, name: "Ranking", icon: "trophy" }],
  2: [{ id: 1, name: "Ranking", icon: "trophy" }],
  3: [{ id: 1, name: "Modo de apresentação", icon: "display" }],
  4: [
    { id: 1, name: "Modo de apresentação", icon: "display" },
    { id: 2, name: "Galeria Post-It", icon: "images" },
  ],
  5: [{ id: 1, name: "Modo de apresentação", icon: "display" }],
  6: [
    { id: 1, name: "Modo de apresentação", icon: "display" },
    { id: 2, name: "QRCode", icon: "qrcode" },
  ],
  7: [{ id: 1, name: "Modo de apresentação", icon: "display" }],
  10: [
    { id: 1, name: "Captura de mídia", icon: "camera" },
    { id: 2, name: "Galeria de Fotos", icon: "images" },
    { id: 3, name: "Biblioteca de Imagens", icon: "folder-open" },
  ],
  11: [
    { id: 1, name: "Modo de apresentação", icon: "display" },
    { id: 2, name: "Galeria com sobreposição", icon: "image-portrait" },
    { id: 3, name: "Captura de fotos", icon: "camera" },
    { id: 4, name: "Biblioteca de imagens", icon: "images" },
  ],
};

export const EventActionLinks = ({ dataTable, notyf, className = "mt-3", shareButtonExtraItems = [] }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showCustomizationModal, setShowCustomizationModal] = useState(false);
  const [shareType, setShareType] = useState("copy");
  const [selectedShareLinkKey, setSelectedShareLinkKey] = useState(null);
  const [shareFlowStep, setShareFlowStep] = useState("links");
  const [selectedShareCustomization, setSelectedShareCustomization] = useState(null);
  const [selectedShareApp, setSelectedShareApp] = useState(null);

  const platform1ShareUrls = getPlatform1ShareUrls(dataTable);
  const eventUrl = platform1ShareUrls.participant;
  const presenterUrl = platform1ShareUrls.presenter;
  const presentationCustomizations = useMemo(
    () => (dataTable.app_details || []).filter((item) => (appModals[item.aplicativo_id] || []).length > 0),
    [dataTable.app_details],
  );

  const links = [
    {
      key: "event",
      label: "Acessar evento",
      enabled: true,
      visible: true,
      shareUrl: eventUrl,
      onClick: () => redirectURL(true, eventUrl),
    },
    {
      key: "presenter",
      label: "Acessar modo apresentador",
      enabled: !!dataTable.codigo_presenter,
      visible: true,
      shareUrl: dataTable.codigo_presenter ? presenterUrl : null,
      onClick: () => redirectURL(true, presenterUrl),
    },
    {
      key: "presentation-screen",
      label: "Acessar tela do modo de apresentação",
      enabled: presentationCustomizations.length > 0,
      visible: true,
      shareUrl: null,
      onClick: () => setShowCustomizationModal(true),
    },
  ];
  const visibleLinks = links.filter((link) => link.visible);
  const shareableLinks = visibleLinks.filter((link) => link.key === "presentation-screen" ? link.enabled : link.shareUrl);
  const hasShareTargets = shareableLinks.length > 0;

  const openShareModal = (type) => {
    setShareType(type);
    setSelectedShareLinkKey(shareableLinks[0]?.key || null);
    setShareFlowStep("links");
    setSelectedShareCustomization(null);
    setSelectedShareApp(null);
    setShowShareModal(true);
  };

  const selectedShareLink = shareableLinks.find((link) => link.key === selectedShareLinkKey);

  const executeShare = async (url) => {
    const shareMessage = `${dataTable.titulo} - ${url}`;

    if (shareType === "copy") {
      await navigator.clipboard.writeText(shareMessage);
      notyf.open({
        type: "success",
        message: "Link copiado para a área de transferência",
        ripple: true,
        dismissible: true,
      });
    }

    if (shareType === "whatsapp") {
      handleSocialShare("whatsapp", `https://wa.me/?text=${encodeURIComponent(shareMessage)}`);
    }

    setShowShareModal(false);
    setShareFlowStep("links");
    setSelectedShareCustomization(null);
    setSelectedShareApp(null);
  };

  const handleSelectShareCustomization = (customization) => {
    setSelectedShareCustomization(customization.customizacao_id);
    setSelectedShareApp(customization);
    setShareFlowStep("modals");
  };

  const handleSelectShareModal = async (modalId) => {
    if (!selectedShareCustomization) {
      return;
    }

    const url = `${presenterUrl}&customizacao_id=${selectedShareCustomization}&modal=${modalId}`;
    await executeShare(url);
  };

  const handleShareBack = () => {
    if (shareFlowStep === "modals") {
      setShareFlowStep("customizations");
      setSelectedShareCustomization(null);
      setSelectedShareApp(null);
      return;
    }

    setShareFlowStep("links");
  };

  const handleShareSubmit = async () => {
    if (!selectedShareLink) {
      return;
    }

    if (selectedShareLink.key === "presentation-screen") {
      setShareFlowStep("customizations");
      return;
    }

    await executeShare(selectedShareLink.shareUrl);
  };

  return (
    <>
      <div className={`d-flex ${className}`.trim()}>
        <Dropdown className="me-2">
          <Dropdown.Toggle variant={"primary"} className="btn btn-sm btn-primary" id="app-share-actions-dropdown">
            <FontAwesomeIcon icon={faShare} className="me-1" />
            Compartilhar
          </Dropdown.Toggle>

          <Dropdown.Menu renderOnMount popperConfig={{ strategy: "fixed" }}>
            {shareButtonExtraItems.map((item) => (
              <Dropdown.Item key={item.key} onClick={item.onClick}>
                {item.icon && <FontAwesomeIcon icon={item.icon} className="me-2" />}
                {item.label}
              </Dropdown.Item>
            ))}
            {shareButtonExtraItems.length > 0 && <Dropdown.Divider />}
            <Dropdown.Item disabled={!hasShareTargets} onClick={() => openShareModal("copy")}>
              <FontAwesomeIcon icon={faCopy} className="me-2" />
              Compartilhar link
            </Dropdown.Item>
            <Dropdown.Item disabled={!hasShareTargets} onClick={() => openShareModal("whatsapp")}>
              <FontAwesomeIcon icon={faWhatsapp} className="me-2" />
              Compartilhar via whatsapp
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown show={showDropdown} onToggle={setShowDropdown}>
          <Dropdown.Toggle variant={"primary"} className="btn-sm" id="app-links-dropdown-status">
            <FontAwesomeIcon icon={faExternalLinkAlt} className="me-1" />
            Links
          </Dropdown.Toggle>

          <Dropdown.Menu renderOnMount popperConfig={{ strategy: "fixed" }}>
            {visibleLinks.map((link) => (
              <Dropdown.Item key={link.key} disabled={!link.enabled} onClick={link.enabled ? link.onClick : undefined}>
                {link.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <Modal show={showShareModal} onHide={() => setShowShareModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Compartilhar link</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {shareFlowStep === "links" && (
            <>
              {shareableLinks.map((link) => (
                <Form.Check
                  key={link.key}
                  type="radio"
                  name="app-share-platform"
                  id={`app-share-platform-${link.key}`}
                  label={link.label}
                  checked={selectedShareLinkKey === link.key}
                  onChange={() => setSelectedShareLinkKey(link.key)}
                  className="mb-2"
                />
              ))}
              {!hasShareTargets && <div className="text-muted">Nenhuma plataforma disponível para compartilhamento.</div>}
            </>
          )}
          {shareFlowStep === "customizations" && (
            <Form.Group>
              <Form.Label>Selecione uma customização para continuar</Form.Label>
              {presentationCustomizations.length > 0 ? (
                <div className="list-group">
                  {presentationCustomizations.map((customization, index) => (
                    <div
                      key={`share-customization-${index}`}
                      className="list-group-item list-group-item-action mb-2 py-2 px-2"
                      aria-current="true"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSelectShareCustomization(customization)}
                    >
                      <div className="d-flex w-100 justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          {customization.imagem && (
                            <img
                              src={`${domainConfig.imageServer}/flex/painel/${customization.imagem}`}
                              alt={customization.titulo || "Customização"}
                              style={{
                                width: "60px",
                                height: "60px",
                                objectFit: "cover",
                                borderRadius: "5px",
                                marginRight: "15px",
                              }}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          )}
                          <div>
                            <h5 className="mb-1">
                              {customization.titulo === "" || !customization.titulo ? (
                                <span className="text-muted">Sem título</span>
                              ) : (
                                customization.titulo
                              )}
                            </h5>
                            <small className="text-muted">{customization.nomeAplicativo}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-4">
                  <p className="text-muted">Nenhuma customização associada a este evento</p>
                </div>
              )}
            </Form.Group>
          )}
          {shareFlowStep === "modals" && (
            <Form.Group>
              <Form.Label>Selecione uma opção</Form.Label>
              {selectedShareApp && appModals[selectedShareApp.aplicativo_id] ? (
                <div className="list-group">
                  {appModals[selectedShareApp.aplicativo_id].map((modal, index) => (
                    <div
                      key={`share-modal-${index}`}
                      className="list-group-item list-group-item-action mb-2 py-3 px-3"
                      aria-current="true"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSelectShareModal(modal.id)}
                    >
                      <div className="d-flex w-100 align-items-center">
                        <div>
                          <h5 className="mb-0">{modal.name}</h5>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-4">
                  <p className="text-muted">Nenhum modal disponível para este aplicativo</p>
                </div>
              )}
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer>
          {shareFlowStep === "links" ? (
            <>
              <Button variant="secondary" onClick={() => setShowShareModal(false)}>
                Cancelar
              </Button>
              <Button variant="primary" onClick={handleShareSubmit} disabled={!selectedShareLink}>
                {selectedShareLink?.key === "presentation-screen"
                  ? "Continuar"
                  : shareType === "copy"
                    ? "Copiar link"
                    : "Compartilhar"}
              </Button>
            </>
          ) : (
            <Button variant="secondary" onClick={handleShareBack}>
              Voltar
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <CustomizationModal
        showCustomizationModal={showCustomizationModal}
        setShowCustomizationModal={setShowCustomizationModal}
        props={dataTable}
        notyf={notyf}
      />
    </>
  );
};

const RegistrationSettings = ({ values, touched, errors, setFieldValue }) => {
  const registrationEndDateIsFuture = isFutureDate(
    values.json.form.register_end_date,
  );
  const registrationStatusIsOpen = isRegistrationOpen(values.json.form.status);
  const registrationIsOpen = isRegistrationOpen(
    values.json.form.status,
    values.json.form.register_end_date,
  );
  const registrationClosed = !registrationIsOpen;

  useEffect(() => {
    if (registrationEndDateIsFuture && !registrationStatusIsOpen) {
      setFieldValue("json.form.status", true, false);
    }
  }, [
    registrationEndDateIsFuture,
    registrationStatusIsOpen,
    setFieldValue,
  ]);

  return (
    <>
      <Row className="mb-3 mx-0">
        <p className="text-start fw-bold mb-2">Inscrições</p>
        <Form.Group as={Col} md="4" className={"mb-3"}>
          <Form.Label>Situação</Form.Label>
          <Form.Select
            name="status"
            onChange={(e) => {
              const newValue =
                e.target.value === true || e.target.value === "true"
                  ? true
                  : false;

              // If reactivating (switching from false to true)
              if (newValue === true && registrationClosed) {
                const reactivationDates = getReactivationDates(
                  values.data_termino,
                );
                setFieldValue(
                  "data_termino",
                  reactivationDates.formattedEventEndDate,
                );
                setFieldValue(
                  "json.form.register_end_date",
                  reactivationDates.formattedRegisterEndDate,
                );
              }

              setFieldValue("json.form.status", newValue);
            }}
            value={registrationIsOpen}
            isInvalid={!!errors.json?.form?.status}
            isValid={touched.json?.form?.status && !errors.json?.form?.status}
          >
            <option value={true}>
              {registrationClosed ? "Reativar" : "Em aberto"}
            </option>
            <option value={false}>Encerrado</option>
          </Form.Select>
          <Form.Control.Feedback type="valid"></Form.Control.Feedback>
          <Form.Control.Feedback type="invalid">
            {errors.json?.form?.status}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3" as={Col} md="4" sm={6}>
          <Form.Label>Data de ínicio</Form.Label>
          <div
            className={`position-relative ${errors.json?.form?.register_start_date ? "is-invalid" : (touched.json?.form?.register_start_date && !errors.json?.form?.register_start_date) ? "is-valid" : ""}`}
          >
            <Datetime
              value={values.json.form.register_start_date}
              onChange={(date) => {
                if (
                  date &&
                  typeof date === "object" &&
                  date._isValid !== false
                ) {
                  const formattedDate = format(
                    new Date(date),
                    "dd/MM/yyyy HH:mm",
                  );
                  setFieldValue("json.form.register_start_date", formattedDate);
                } else {
                  setFieldValue("json.form.register_start_date", "");
                }
              }}
              dateFormat="DD/MM/YYYY"
              timeFormat="HH:mm"
              inputProps={{
                name: "json.form.register_start_date",
                placeholder: "dd/MM/yyyy HH:mm",
                className: `form-control ${errors.json?.form?.register_start_date
                  ? "is-invalid"
                  : touched.json?.form?.register_start_date &&
                    !errors.json?.form?.register_start_date
                    ? "is-valid"
                    : ""
                  }`,
              }}
              locale="pt-br"
            />
          </div>
          {touched.json?.form?.register_start_date &&
            !errors.json?.form?.register_start_date && (
              <div className="valid-feedback d-block"></div>
            )}
          {errors.json?.form?.register_start_date && (
            <div className="invalid-feedback d-block">
              {errors.json?.form?.register_start_date}
            </div>
          )}
        </Form.Group>

        <Form.Group className="mb-3" as={Col} md="4" sm={6}>
          <Form.Label>Data de término</Form.Label>
          <div
            className={`position-relative ${errors.json?.form?.register_end_date ? "is-invalid" : (touched.json?.form?.register_end_date && !errors.json?.form?.register_end_date) ? "is-valid" : ""}`}
          >
            <Datetime
              value={values.json.form.register_end_date}
              onChange={(date) => {
                if (
                  date &&
                  typeof date === "object" &&
                  date._isValid !== false
                ) {
                  const formattedDate = format(
                    new Date(date),
                    "dd/MM/yyyy HH:mm",
                  );
                  setFieldValue("json.form.register_end_date", formattedDate);
                } else {
                  setFieldValue("json.form.register_end_date", "");
                }
              }}
              dateFormat="DD/MM/YYYY"
              timeFormat="HH:mm"
              inputProps={{
                name: "json.form.register_end_date",
                placeholder: "dd/MM/yyyy HH:mm",
                className: `form-control ${errors.json?.form?.register_end_date
                  ? "is-invalid"
                  : touched.json?.form?.register_end_date &&
                    !errors.json?.form?.register_end_date
                    ? "is-valid"
                    : ""
                  }`,
              }}
              locale="pt-br"
              isValidDate={(current) => {
                // Only allow dates >= register_start_date if register_start_date is set
                if (values.json.form.register_start_date) {
                  try {
                    const startDate = parse(
                      values.json.form.register_start_date,
                      "dd/MM/yyyy HH:mm",
                      new Date(),
                    );
                    if (isValid(startDate)) {
                      return current.toDate() >= startDate;
                    }
                  } catch {
                    return true;
                  }
                }
                return true;
              }}
            />
          </div>
          {touched.json?.form?.register_end_date &&
            !errors.json?.form?.register_end_date && (
              <div className="valid-feedback d-block"></div>
            )}
          {errors.json?.form?.register_end_date && (
            <div className="invalid-feedback d-block">
              {errors.json?.form?.register_end_date}
            </div>
          )}
        </Form.Group>
      </Row>

    </>
  );
};

export const EventDefinitions = ({
  dataTable,
  values,
  touched,
  errors,
  handleChange,
  setFieldValue,
  setActiveTab,
}) => {
  const eventEndDateIsFuture = isFutureDate(values.data_termino);
  const effectiveEventStatus = eventEndDateIsFuture ? 2 : values.status;

  useEffect(() => {
    if (eventEndDateIsFuture && Number(values.status) !== 2) {
      setFieldValue("status", 2, false);
    }
  }, [eventEndDateIsFuture, setFieldValue, values.status]);

  return (
    <>
      <Row className="mb-3">
        <Form.Control type="hidden" name="status" value={true} />
        <Form.Control type="hidden" name="evento_id" value={values.evento_id} />
        <Form.Group className="mb-3" as={Col} sm="12">
          <Form.Label>Título</Form.Label>
          <Form.Control
            type="text"
            name="titulo"
            value={values.titulo}
            onChange={handleChange}
            isInvalid={!!errors.titulo}
            isValid={touched.titulo && !errors.titulo}
          />
          <Form.Control.Feedback type="valid"></Form.Control.Feedback>
          <Form.Control.Feedback type="invalid">
            {errors.titulo}
          </Form.Control.Feedback>
        </Form.Group>

        {/* <Form.Group className="mb-3" as={Col} sm="12">
          <Form.Label>Descrição</Form.Label>
          <Form.Control
            name="descricao"
            as="textarea"
            value={values.descricao}
            onChange={handleChange}
            isInvalid={!!errors.descricao}
            isValid={touched.descricao && !errors.descricao}
          />
          <Form.Control.Feedback type="valid"></Form.Control.Feedback>
          <Form.Control.Feedback type="invalid">
            {errors.descricao}
          </Form.Control.Feedback>
        </Form.Group> */}

        <Form.Group as={Col} md="3" className={"mb-3"}>
          <Form.Label>Status do evento</Form.Label>
          <Form.Select
            name="status"
            disabled={Number(effectiveEventStatus) > 1 ? false : true}
            onChange={(e) => {
              const currentStatus = Number(effectiveEventStatus);
              const newStatus = Number(e.target.value);

              if (currentStatus > 1) {
                // When reactivating (selecting status 2 from status 3 or 4)
                if (newStatus === 2 && [3, 4].includes(currentStatus)) {
                  const reactivationDates = getReactivationDates(
                    values.data_termino,
                    true,
                  );
                  setFieldValue(
                    "data_termino",
                    reactivationDates.formattedEventEndDate,
                  );
                  setFieldValue(
                    "json.form.register_end_date",
                    reactivationDates.formattedRegisterEndDate,
                  );
                }
                setFieldValue("status", newStatus);
              }
            }}
            value={effectiveEventStatus}
            isInvalid={!!errors.status}
            isValid={touched.status && !errors.status}
          >
            {statusX.map((element, index) => {
              const currentStatus = Number(effectiveEventStatus);

              if (currentStatus > 1) {
                if (index > 1) {
                  // Check if this is "Em andamento" (index 2) and values.status is 3 or 4
                  if (index === 2 && [3, 4].includes(currentStatus)) {
                    return (
                      <option key={"status" + index} value={index}>
                        Reativar
                      </option>
                    );
                  }
                  return (
                    <option key={"status" + index} value={index}>
                      {element}
                    </option>
                  );
                } else {
                  return "";
                }
              } else {
                return (
                  <option key={"status" + index} value={index}>
                    {element}
                  </option>
                );
              }
            })}
          </Form.Select>
          <Form.Control.Feedback type="valid"></Form.Control.Feedback>
          <Form.Control.Feedback type="invalid">
            {errors.status}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3" as={Col} md="3" sm={6}>
          <Form.Label>Data de criação</Form.Label>
          <InputMask
            disabled
            mask="99/99/9999 99:99"
            value={values.data_criacao}
            isInvalid={!!errors.data_criacao}
            isValid={touched.data_criacao && !errors.data_criacao}
          >
            {(inputProps) => (
              <Form.Control
                disabled
                {...inputProps}
                type="text"
                name="data_criacao"
              />
            )}
          </InputMask>
          <Form.Control.Feedback type="valid"></Form.Control.Feedback>
          <Form.Control.Feedback type="invalid">
            {errors.data_criacao}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3" as={Col} md="3" sm={6}>
          <Form.Label>Data de término</Form.Label>
          <div
            className={`position-relative ${errors.data_termino ? "is-invalid" : (touched.data_termino && !errors.data_termino) ? "is-valid" : ""}`}
          >
            <Datetime
              value={values.data_termino}
              onChange={(date) => {
                if (
                  date &&
                  typeof date === "object" &&
                  date._isValid !== false
                ) {
                  const formattedDate = format(
                    new Date(date),
                    "dd/MM/yyyy HH:mm",
                  );
                  setFieldValue("data_termino", formattedDate);
                } else {
                  setFieldValue("data_termino", "");
                }
              }}
              dateFormat="DD/MM/YYYY"
              timeFormat="HH:mm"
              inputProps={{
                name: "data_termino",
                placeholder: "dd/MM/yyyy HH:mm",
                className: `form-control ${errors.data_termino
                  ? "is-invalid"
                  : touched.data_termino && !errors.data_termino
                    ? "is-valid"
                    : ""
                  }`,
              }}
              locale="pt-br"
            />
          </div>
          {touched.data_termino && !errors.data_termino && (
            <div className="valid-feedback d-block"></div>
          )}
          {errors.data_termino && (
            <div className="invalid-feedback d-block">
              {errors.data_termino}
            </div>
          )}
        </Form.Group>
      </Row>
      <Row className="mb-3">
        <p className="text-start fw-bold mb-2">Módulos</p>
        <Form.Group className="mb-3">
          <Form.Check
            className="w-auto"
            checked={values.json.applications.status ? true : false}
            type="checkbox"
            name="json.applications.status"
            label="Aplicativos"
            onChange={(e) => {
              const newStatus = !values.json.applications.status;
              setFieldValue("json.applications.status", newStatus);
              // Auto-switch tabs based on module status
              if (setActiveTab) {
                if (newStatus) {
                  // Switch to applications tab when enabled
                  setActiveTab("applications");
                } else {
                  // Switch to form tab when disabled
                  setActiveTab("form");
                }
              }
            }}
          />
        </Form.Group>
      </Row>
    </>
  );
};

export const AdvancedSettingsDefinitions = ({
  values,
  touched,
  errors,
  handleChange,
  setFieldValue,
  onDelete,
}) => {
  const userState = useAuth();
  const selectEventsData = useAppSelector(selectEvents);

  return (
    <>
      <Row className="mx-0 mb-3">
        {userState.tipo === 1 && (
          <>
            <p className="text-start fw-bold mb-2">
              <FontAwesomeIcon icon={faUserSecret} className="me-1" /> Administrador
            </p>
            <Form.Group as={Col} md="12" className={"mb-3"}>
              <Form.Label>Conta associada</Form.Label>
              <Select
                className="px-0"
                options={selectEventsData.usersList}
                getOptionLabel={(option) => option.email}
                getOptionValue={(option) => option.user_id}
                defaultValue={selectEventsData.usersList.find(
                  (user) => user.user_id === values.user_id,
                )}
                onChange={(option) => setFieldValue("user_id", option.user_id)}
                placeholder={"Clique para selecionar..."}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    padding: 5,
                  }),
                }}
              />
            </Form.Group>
          </>
        )}
      </Row>
      <Row className="mx-0 mb-3">
        <p className="text-start fw-bold mb-2">
          <FontAwesomeIcon icon={faStream} className="me-1" /> Comportamentos
        </p>
        <Form.Group className="mb-3">
          <Form.Check
            className="mb-0"
            checked={values.json.noCache ? true : false}
            type="checkbox"
            name="json.noCache"
            label='Ao reiniciar página retornar ao formulário inicial'
            onChange={(e) => {
              setFieldValue(
                "json.noCache",
                values.json.noCache ? false : true
              );
            }}
          />
        </Form.Group>
      </Row>

      <Form.Group as={Col} className="mx-2 mt-3 pt-3">
        <h5 className="card-title mb-0"><FontAwesomeIcon
          icon={faExclamationCircle}
          className="me-1 text-danger"
        />Zona de Perigo</h5>
        <hr className="mt-2"></hr>
      </Form.Group>
      <Row className="mx-0 mb-3">
        <Form.Group className="mb-3">
          <Card className="border-danger">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <Card.Title className="text-danger mb-1" style={{ fontSize: "0.9rem" }}>
                    Exclusão do evento
                  </Card.Title>
                  <Card.Text className="text-muted mb-0" style={{ fontSize: "0.8rem" }}>
                    Uma vez excluído, todos os dados do evento, participantes e configurações serão removidos permanentemente. Esta ação não pode ser desfeita.
                  </Card.Text>
                </div>
              </div>
              <div className="mt-2">
                <Button
                  type="button"
                  variant="outline-danger"
                  className="btn-sm"
                  onClick={onDelete}
                >
                  Sim, desejo excluir o evento
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Form.Group>
      </Row>
    </>
  );
};

export const RegisterDefinitions = ({
  dataTable,
  values,
  touched,
  errors,
  handleChange,
  setFieldValue,
  setDataAddForm,
  dataAddForm,
  setModal,
}) => {
  const importUsersInput = useRef();
  const location = useLocation();
  const registeredParticipants = Math.max(
    Number(dataTable?.total_participantes) || 0,
    0,
  );

  return (
    <>
      <RegistrationSettings
        values={values}
        touched={touched}
        errors={errors}
        setFieldValue={setFieldValue}
      />
      <Row className="mb-3 mx-0">
        <Form.Label>Composição do formulário dos participante</Form.Label>
        <FormCompositionCard
          platform={dataTable.platform}
          dataAddForm={dataAddForm}
          setDataAddForm={setDataAddForm}
          setModal={setModal}
          values={values}
          setFieldValue={setFieldValue}
        ></FormCompositionCard>
      </Row>

      <Row className="mx-0">
        <Form.Group className="mb-3">
          <Form.Check
            checked={
              values.json.form.authorizationMessage.status ? true : false
            }
            type="checkbox"
            name="json.form.authorizationMessage.status"
            label="Checkbox de Consentimento"
            onChange={(e) => {
              setFieldValue(
                "json.form.authorizationMessage.status",
                values.json.form.authorizationMessage.status ? false : true,
              );
            }}
          />
          {values.json.form.authorizationMessage.status ? (
            <div className="border p-3 mt-2 mb-3">
              <Form.Group className="mb-3" as={Col} sm="6">
                <Form.Label>Texto</Form.Label>
                <Form.Control
                  name="json.form.authorizationMessage.value"
                  value={values.json.form.authorizationMessage.value}
                  onChange={handleChange}
                  isInvalid={!!errors?.json?.form?.authorizationMessage?.value}
                  isValid={
                    touched?.json?.form?.authorizationMessage?.value &&
                    !errors?.json?.form?.authorizationMessage?.value
                  }
                />
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors?.json?.form?.authorizationMessage?.value}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} sm="6">
                <Form.Label>Política de Privacidade (URL)</Form.Label>
                <Form.Control
                  name="json.form.authorizationLink"
                  value={values.json.form.authorizationLink}
                  onChange={handleChange}
                  isInvalid={!!errors?.json?.form?.authorizationLink}
                  isValid={
                    touched?.json?.form?.authorizationLink &&
                    !errors?.json?.form?.authorizationLink
                  }
                />
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors?.json?.form?.authorizationLink}
                </Form.Control.Feedback>
              </Form.Group>
            </div>
          ) : (
            ""
          )}
        </Form.Group>
      </Row>



      <Row className="mx-0 mb-3">
        <p className="text-start fw-bold mb-2">
          Regras de inscrição
        </p>
        <Form.Group className="mb-3">
          <Form.Check
            checked={values.json.subscriptionLimit.status ? true : false}
            type="checkbox"
            name="json.subscriptionLimit.status"
            label="Ativar limite de inscrições"
            onChange={(e) => {
              setFieldValue(
                "json.subscriptionLimit.status",
                values.json.subscriptionLimit.status ? false : true,
              );
            }}
          />
          {values.json.subscriptionLimit.status ? (
            <div className="border p-3 mt-2 mb-3">
              <Form.Group className="mb-3">
                <Form.Label>Total de inscrições disponíveis</Form.Label>
                <Form.Control
                  type={"number"}
                  name="json.subscriptionLimit.limit"
                  min={registeredParticipants}
                  step={1}
                  value={values.json.subscriptionLimit.limit}
                  onChange={(event) => {
                    const rawValue = event.target.value;
                    if (rawValue === "") {
                      setFieldValue("json.subscriptionLimit.limit", "");
                      return;
                    }

                    const enteredValue = Number(rawValue);
                    setFieldValue(
                      "json.subscriptionLimit.limit",
                      Number.isFinite(enteredValue)
                        ? Math.max(Math.trunc(enteredValue), registeredParticipants)
                        : rawValue,
                    );
                  }}
                  isInvalid={!!errors?.json?.subscriptionLimit?.limit}
                  isValid={
                    touched?.json?.subscriptionLimit?.limit &&
                    !errors?.json?.subscriptionLimit?.limit
                  }
                />
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors?.json?.subscriptionLimit?.limit}
                </Form.Control.Feedback>
                <Form.Text className="text-muted d-block mt-1">
                  Participantes registrados: {registeredParticipants}
                </Form.Text>
              </Form.Group>
              <p className="text-start fw-bold mb-2">
                Tela de aviso
                <OverlayTrigger
                  overlay={
                    <Tooltip>
                      O usuário será redirecionado para essa tela em caso de
                      limite de inscrição atingido
                    </Tooltip>
                  }
                >
                  <HelpTooltip icon={faExclamationCircle} />
                </OverlayTrigger>
              </p>
              <Form.Group className="mb-3" as={Col} sm="12">
                <Form.Label>Título</Form.Label>
                <Form.Control
                  as="textarea"
                  name="json.subscriptionLimit.disableFormTitle"
                  value={values.json.subscriptionLimit.disableFormTitle}
                  onChange={handleChange}
                  isInvalid={!!errors?.json?.subscriptionLimit?.disableFormTitle}
                  isValid={
                    touched?.json?.subscriptionLimit?.disableFormTitle &&
                    !errors?.json?.subscriptionLimit?.disableFormTitle
                  }
                />
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors?.json?.subscriptionLimit?.disableFormTitle}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" as={Col} sm="12">
                <Form.Label>Descrição</Form.Label>
                <Form.Control
                  as="textarea"
                  name="json.subscriptionLimit.disableDescription"
                  value={values.json.subscriptionLimit.disableDescription}
                  onChange={handleChange}
                  isInvalid={
                    !!errors?.json?.subscriptionLimit?.disableDescription
                  }
                  isValid={
                    touched?.json?.subscriptionLimit?.disableDescription &&
                    !errors?.json?.subscriptionLimit?.disableDescription
                  }
                />
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors?.json?.subscriptionLimit?.disableDescription}
                </Form.Control.Feedback>
              </Form.Group>
            </div>) : ""}
          <Form.Check
            checked={values.json.form.validEmails?.status || false}
            type="checkbox"
            name="json.form.validEmails.status"
            label={
              <>
                Restringir domínios de e-mail permitidos
                <OverlayTrigger
                  overlay={
                    <Tooltip>
                      Quando ativado, apenas e-mails dos domínios especificados
                      serão aceitos no registro
                    </Tooltip>
                  }
                >
                  <HelpTooltip icon={faExclamationCircle} />
                </OverlayTrigger>
              </>
            }
            onChange={(e) => {
              setFieldValue("json.form.validEmails.status", e.target.checked);
            }}
          />
        </Form.Group>
      </Row>

      <Form.Group as={Col} className="textHeaderAplicativo mb-3 mx-2">
        <h5 className="card-title mb-0">
          Adicionar registros
        </h5>
      </Form.Group>
      <Row className="mx-0">
        <Form.Group className="mb-3" as={Col} sm="12">
          <p className="text-start fw-bold mb-1">
            Importar participantes (
            {dataAddForm.importUsers.users.length > 0
              ? dataAddForm.importUsers.users.length
              : 0}
            )
            <OverlayTrigger
              overlay={
                <Tooltip>
                  Use apenas arquivos .xlsx, .xls ou .csv. Os títulos definidos
                  no formulário devem ser os mesmos do cabeçalho do arquivo.
                  Valores de identificação repetidos bloqueiam a importação.
                </Tooltip>
              }
            >
              <HelpTooltip icon={faExclamationCircle} />
            </OverlayTrigger>
          </p>
          <Button
            type="button"
            variant="primary"
            className="btn-sm"
            onClick={() =>
              generateExcelTemplate(
                dataTable.platform,
                dataTable.titulo,
                dataAddForm,
              )
            }
          >
            Baixar modelo
          </Button>
          <Button
            type="button"
            onClick={() => openHelpCenter("/ajuda/plataforma-eventos/gestao-evento/importacao")}
            variant="outline-secondary"
            className="btn-sm ms-2"
          >
            Central de ajuda
          </Button>
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm="12">
          <Form.Check
            type="checkbox"
            className="mb-3"
            label="Modo de emergência: ignorar validações locais de conteúdo"
            checked={dataAddForm.importUsers.disableValidation || false}
            onChange={(e) => {
              if (e.target.checked) {
                confirmAlert({
                  closeOnEscape: false,
                  closeOnClickOutside: false,
                  customUI: ({ onClose }) => {
                    return (
                      <ShowConfirm
                        title="Confirmar ação"
                        description="Use apenas para recuperação. Este modo mantém as validações do arquivo e dos cabeçalhos, mas ignora regras locais de conteúdo. O servidor ainda valida e-mail, duplicidade e vagas. Deseja continuar?"
                        action={() => {
                          setDataAddForm((prev) => ({ ...prev, importUsers: { ...prev.importUsers, disableValidation: true } }));
                          onClose();
                        }}
                        onClose={onClose}
                      />
                    );
                  },
                });
              } else {
                setDataAddForm((prev) => ({ ...prev, importUsers: { ...prev.importUsers, disableValidation: false } }));
              }
            }}
          />

          <InputGroup>
            <Form.Control
              type="file"
              accept=".xlsx,.xls,.csv"
              onChange={(e) =>
                handleFileUpload(
                  dataTable.platform,
                  e,
                  dataAddForm,
                  setDataAddForm,
                  importUsersInput,
                  {
                    fields: dataAddForm.fields,
                    event_id: dataTable.evento_id,
                    platform: dataTable.platform,
                    validEmailsConfig: values.json.form.validEmails,
                    eventJson: {
                      ...values.json,
                      form: { ...values.json.form, fields: dataAddForm.fields },
                    },
                    skipRowValidation: dataAddForm.importUsers.disableValidation,
                  },
                )
              }
              isInvalid={!!dataAddForm.importUsers.error}
              isValid={Boolean(dataAddForm.importUsers.formFilename) && !dataAddForm.importUsers.error}
              ref={importUsersInput}
            />
            <OverlayTrigger overlay={<Tooltip>Resetar</Tooltip>}>
              <InputGroup.Text
                onClick={() => {
                  setDataAddForm((prevState) => ({
                    ...prevState,
                    importUsers: {
                      ...prevState.importUsers,
                      users: [],
                      fields: [],
                      error: "",
                      errorList: [],
                      report: null,
                      formValue: "",
                      formFilename: "",
                    },
                  }));
                  importUsersInput.current.value = "";
                }}
              >
                <FontAwesomeIcon icon={faRefresh} />
              </InputGroup.Text>
            </OverlayTrigger>
          </InputGroup>
          <Form.Control.Feedback type="valid"></Form.Control.Feedback>
          <div
            className="invalid-feedback d-flex align-items-center"
            style={{ display: dataAddForm.importUsers.error ? "block" : "none" }}
          >
            <span className="me-2">{dataAddForm.importUsers.error}</span>
            {dataAddForm.importUsers.errorList && dataAddForm.importUsers.errorList.length > 0 && (
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => setDataAddForm((prev) => ({
                  ...prev,
                  importUsers: { ...prev.importUsers, report: { ...(prev.importUsers.report || { errors: prev.importUsers.errorList }), open: true } },
                }))}
              >
                Ver detalhes
              </Button>
            )}
          </div>
        </Form.Group>
      </Row>
      <Row className="mx-0">
        <Col md={12} className="mb-3">
          <Card className="mb-3">
            <Card.Body className="overflow-auto">
              <ColumnSortingTable
                columns={dataAddForm.importUsers.fields}
                data={dataAddForm.importUsers.users}
                title={dataTable.titulo}
                removeCard={true}
                getCellProps={(cellinfo) => ({
                  className:
                    cellinfo.column.id === "icons" ? "table-icons-triple" : "",
                })}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <ImportValidationReportModal
        report={dataAddForm.importUsers.report}
        onClose={() => setDataAddForm((prev) => ({
          ...prev,
          importUsers: { ...prev.importUsers, report: { ...prev.importUsers.report, open: false } },
        }))}
      />
    </>
  );
};

export const AppDefinitions = ({
  dataTable,
  values,
  touched,
  errors,
  handleChange,
  setFieldValue,
  setDataAddForm,
  dataAddForm,
  handlePreviewError,
  fonts,
  setModal,
  applications,
  setApplications,
  setDataAplicativo,
}) => {
  const isSimplifiedCustomizationEnabled = (personalizationType) =>
    personalizationType ? personalizationType === "simplified" : true;
  const [isSimplifiedCustomization, setIsSimplifiedCustomization] = useState(
    isSimplifiedCustomizationEnabled(values?.json?.personalizationType),
  );

  const [props, setProps] = useState({
    primaryColor: dataTable.json.primaryColor,
    primaryColorText: dataTable.json.primaryColorText,
    backgroundColor: dataTable.json.background.color,
    baseColorText: dataTable.json.baseColorText,
    transparency: dataTable.json.transparency,
    boxShadow: dataTable.json.boxShadow,
    bsBorderColor: dataTable.json.bsBorderColor,
  });

  useEffect(() => {
    setIsSimplifiedCustomization(
      isSimplifiedCustomizationEnabled(values?.json?.personalizationType),
    );
  }, [values?.json?.personalizationType]);

  useEffect(() => {
    const json = values?.json;
    if (!json) return;

    setProps((prevState) => ({
      ...prevState,
      primaryColor: json.primaryColor,
      primaryColorText: json.primaryColorText,
      backgroundColor: json.background?.color,
      baseColorText: json.baseColorText,
      transparency: json.transparency,
      boxShadow: json.boxShadow,
      bsBorderColor: json.bsBorderColor,
    }));
  }, [
    values?.json?.primaryColor,
    values?.json?.primaryColorText,
    values?.json?.background?.color,
    values?.json?.baseColorText,
    values?.json?.transparency,
    values?.json?.boxShadow,
    values?.json?.bsBorderColor,
  ]);

  const applyLayoutStyle = (type) => {
    const isCardLayout = type === 2;
    const layoutTransparency = isCardLayout
      ? "rgba(255, 255, 255, 1)"
      : "rgba(255, 255, 255, 0)";
    const backgroundColor = values?.json?.background?.type === "color"
      ? values.json.background.color
      : "#ffffff";
    const layoutValues = {
      transparency: layoutTransparency,
      boxShadow: isCardLayout
        ? "rgba(0, 0, 0, 0.15)"
        : "rgba(0, 0, 0, 0)",
      baseColorText:
        getContrastColor(layoutTransparency, backgroundColor) ||
        "rgba(33, 37, 41, 1)",
      bsBorderColor: isCardLayout
        ? "rgba(0, 0, 0, 0.1)"
        : "rgba(206, 212, 218, 1)",
    };

    setFieldValue("json.layout.type", type);
    setFieldValue("json.mainLayout.justifyContent", "center");
    setFieldValue("json.mainLayout.paddingBox", "1.50 1.50 1.50 1.50");
    setFieldValue(
      "json.paddingBox",
      isCardLayout
        ? "1.50 1.50 1.50 1.50"
        : "0.00 0.00 0.00 0.00",
    );
    setFieldValue("json.transparency", layoutValues.transparency);
    setFieldValue("json.boxShadow", layoutValues.boxShadow);
    setFieldValue("json.baseColorText", layoutValues.baseColorText);
    setFieldValue("json.bsBorderColor", layoutValues.bsBorderColor);

    setProps((prevState) => ({
      ...prevState,
      ...layoutValues,
    }));
  };

  const applySimplifiedTheme = (primaryColor) => {
    const contrast = getContrastColor(primaryColor) || "#ffffff";

    setFieldValue("json.personalizationType", "simplified");
    setFieldValue("json.primaryColor", primaryColor);
    setFieldValue("json.primaryColorText", contrast);
    applyLayoutStyle(2);

    setProps((prevState) => ({
      ...prevState,
      primaryColor: primaryColor,
      primaryColorText: contrast,
    }));
  };

  return (
    <>
      <AppApplications
        setModal={setModal}
        applications={applications}
        setApplications={setApplications}
        setDataAplicativo={setDataAplicativo}
        values={values}
        touched={touched}
        errors={errors}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
      />
      <Form.Group as={Col} className="textHeaderAplicativo mb-3 mx-2">
        <h5 className="card-title mb-0">Customização</h5>
      </Form.Group>
      <Row className="mx-0 mb-3 align-items-center">
        <Form.Group>
          <Form.Check
            type="checkbox"
            id="simplified-customization-switch"
            label="Personalização Simplificada"
            checked={isSimplifiedCustomization}
            onChange={(e) => {
              const isChecked = e.target.checked;
              if (isChecked) {
                confirmAlert({
                  closeOnEscape: false,
                  closeOnClickOutside: false,
                  customUI: ({ onClose }) => {
                    return (
                      <ShowConfirm
                        title="Confirmar ação"
                        description="Habilitar a personalização simplificada substituirá o tema atual para um layout padrão. Deseja continuar?"
                        action={() => {
                          setIsSimplifiedCustomization(true);
                          setFieldValue("json.personalizationType", "simplified");
                          applySimplifiedTheme("rgb(215, 205, 18)");
                          onClose();
                        }}
                        onClose={() => {
                          onClose();
                        }}
                      />
                    );
                  },
                });
              } else {
                setIsSimplifiedCustomization(false);
                setFieldValue("json.personalizationType", "advanced");
              }
            }}
          />
        </Form.Group>
      </Row>

      {isSimplifiedCustomization && (
        <>
          <Row className="mx-0 mb-3">
            <Col md="12" className="mb-3">
              <p className="text-start fw-bold mb-2">Perfil do Aplicativo</p>
              <Row className="gx-3 align-items-start mb-0">
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Estilo de Layout</Form.Label>
                    <Form.Select
                      value={values.json.layout.type}
                      onChange={(e) => {
                        const type = parseInt(e.target.value);
                        applyLayoutStyle(type);
                      }}
                    >
                      <option value={2}>Layout em Cartão (Com Container)</option>
                      <option value={1}>Layout Minimalista (Sem Container)</option>
                    </Form.Select>
                    <Form.Text className="text-muted mt-2 d-block">
                      {values.json.layout.type === 2
                        ? "O Layout em Cartão é ideal para uso com imagens no plano de fundo."
                        : "O Layout Minimalista exibe o conteúdo direto sobre o plano de fundo."}
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-0">
                    <Form.Label>Cores</Form.Label>
                    <Row className="mb-2">
                      <div
                        className={`d-flex justify-content-start align-items-center ${errors?.json?.primaryColor ? "is-invalid" : ""}`}
                      >
                        <PopoverPicker
                          color={props.primaryColor}
                          onChangeX={(e) => {
                            setFieldValue("json.primaryColor", e);
                            const contrast = getContrastColor(e);
                            if (contrast) {
                              setFieldValue("json.primaryColorText", contrast);
                            }
                            setProps((prevState) => ({
                              ...prevState,
                              primaryColor: e,
                              ...(contrast ? { primaryColorText: contrast } : {}),
                            }));
                          }}
                          classes={`me-1 picker ${errors?.json?.primaryColor ? "is-invalid" : ""}`}
                        />
                        <Form.Label className="mb-0 ms-2">
                          Cor primária
                          <OverlayTrigger
                            overlay={
                              <Tooltip>
                                Para melhor legibilidade, recomendamos uma cor de destaque diferente de preto e branco.
                              </Tooltip>
                            }
                          >
                            <span className="ms-1 d-inline-block">
                              <HelpTooltip icon={faExclamationCircle} />
                            </span>
                          </OverlayTrigger>
                        </Form.Label>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {getFirstError(errors?.json?.primaryColor)}
                      </Form.Control.Feedback>
                    </Row>
                    <Row className="mb-2">
                      <div
                        className={`d-flex justify-content-start align-items-center ${errors?.json?.transparency ? "is-invalid" : ""}`}
                      >
                        <PopoverPicker
                          color={props.transparency}
                          onChangeX={(e) => {
                            setFieldValue("json.transparency", e);
                            setProps((prevState) => ({
                              ...prevState,
                              transparency: e,
                            }));
                          }}
                          classes={`me-1 picker ${errors?.json?.transparency ? "is-invalid" : ""}`}
                        />
                        <Form.Label className="mb-0 ms-2">Cor do container</Form.Label>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {getFirstError(errors?.json?.transparency)}
                      </Form.Control.Feedback>
                    </Row>
                    <Row className="mb-2">
                      <div
                        className={`d-flex justify-content-start align-items-center ${errors?.json?.baseColorText ? "is-invalid" : ""}`}
                      >
                        <PopoverPicker
                          color={props.baseColorText}
                          onChangeX={(e) => {
                            setFieldValue("json.baseColorText", e);
                            setProps((prevState) => ({
                              ...prevState,
                              baseColorText: e,
                            }));
                          }}
                          classes={`me-1 picker ${errors?.json?.baseColorText ? "is-invalid" : ""}`}
                        />
                        <Form.Label className="mb-0 ms-2">Cor do texto</Form.Label>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {getFirstError(errors?.json?.baseColorText)}
                      </Form.Control.Feedback>
                    </Row>
                  </Form.Group>
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      )}

      {!isSimplifiedCustomization && (
        <>
          <Row className="mx-0">
            <p className="text-start fw-bold mb-2">Contêiner externo</p>
            <Form.Group as={Col} md={4} className="mb-3">
              <Form.Label>Alinhar verticalmente</Form.Label>
              <Form.Select
                name="json.mainLayout.justifyContent"
                value={values.json.mainLayout.justifyContent}
                onChange={(e) => {
                  setFieldValue("json.mainLayout.justifyContent", e.target.value);
                }}
                isInvalid={!!errors.json?.mainLayout?.justifyContent}
                isValid={
                  touched.json?.mainLayout?.justifyContent &&
                  !errors.json?.mainLayout?.justifyContent
                }
              >
                <option value={"flex-start"}>Topo</option>
                <option value={"center"}>Centro</option>
                <option value={"flex-end"}>Base</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.json?.mainLayout?.justifyContent}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md={4} className="mb-3">
              <Form.Label>
                Margem (rem)
              </Form.Label>
              <InputMask
                mask="9.99 9.99 9.99 9.99"
                value={values.json.mainLayout.paddingBox}
                onChange={handleChange}
                isInvalid={!!errors.json?.mainLayout?.paddingBox}
                isValid={
                  touched.json?.mainLayout?.paddingBox &&
                  !errors.json?.mainLayout?.paddingBox
                }
              >
                {(inputProps) => (
                  <Form.Control
                    {...inputProps}
                    type="text"
                    name="json.mainLayout.paddingBox"
                  />
                )}
              </InputMask>
              <Form.Control.Feedback type="valid"></Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                {errors.json?.mainLayout?.paddingBox}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3 mx-0">
            {values.json.layout.type === 1 && (
              <Form.Group as={Col} md="4" className="mb-3">
                <Form.Label>Rodapé</Form.Label>
                <Form.Select
                  name="json.layout.footer.type"
                  onChange={(e) => {
                    if (e.target.value === "noFooter")
                      setFieldValue("json.layout.footer.socialMedia", []);
                    setFieldValue("json.layout.footer.type", e.target.value);
                  }}
                  value={values.json.layout.footer.type}
                  isInvalid={!!errors.json?.layout?.footer?.type}
                  isValid={
                    touched.json?.layout?.footer?.type &&
                    !errors.json?.layout?.footer?.type
                  }
                >
                  <option value={"noFooter"}>Sem rodapé</option>
                  <option value={"image"}>Imagem</option>
                  <option value={"icons"}>Ícones</option>
                </Form.Select>
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors.json?.layout?.footer?.type}
                </Form.Control.Feedback>
              </Form.Group>
            )}
            {values.json.layout.type === 1 ? (
              <FooterFormComponent
                dataAddForm={dataAddForm}
                setDataAddForm={setDataAddForm}
                setModal={setModal}
                touched={touched}
                errors={errors}
                values={values}
                setFieldValue={setFieldValue}
                handlePreviewSuccess={handlePreviewSuccess}
                handlePreviewError={handlePreviewError}
                platform={dataTable.platform}
              ></FooterFormComponent>
            ) : (
              ""
            )}
          </Row>
          <Row className="mx-0 mb-3">
            <p className="text-start fw-bold mb-2">Contêiner interno</p>
            <Form.Group as={Col} md="4" className="mb-3">
              <Form.Label>Tipo de layout</Form.Label>
              <Form.Select
                name="json.layout.type"
                onChange={(e) => {
                  setFieldValue(
                    "json.layout.type",
                    e.target.value === "1" ? 1 : 2,
                  );
                }}
                value={values.json.layout.type}
                isInvalid={!!errors.json?.layout?.type}
                isValid={touched.json?.layout?.type && !errors.json?.layout?.type}
              >
                {layoutX.map((element, index) => {
                  return (
                    <option key={"layout" + index} value={parseInt(index + 1)}>
                      {element}
                    </option>
                  );
                })}
              </Form.Select>
              <Form.Control.Feedback type="valid"></Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                {errors.json?.layout?.type}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md={4} className="mb-3">
              <Form.Label>
                Margem (rem)
              </Form.Label>
              <InputMask
                mask="9.99 9.99 9.99 9.99"
                value={values.json.paddingBox}
                onChange={handleChange}
                isInvalid={!!errors.json?.paddingBox}
                isValid={touched.json?.paddingBox && !errors.json?.paddingBox}
              >
                {(inputProps) => (
                  <Form.Control
                    {...inputProps}
                    type="text"
                    name="json.paddingBox"
                  />
                )}
              </InputMask>
              <Form.Control.Feedback type="valid"></Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                {errors.json?.paddingBox}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Row className="mx-0 mb-3">
            <p className="text-start fw-bold mb-2">Fonte</p>
            <Form.Group as={Col} md={4} className="mb-3">
              <Form.Label>
                Estilo{" "}
                <span
                  className="badge text-dark bg-light cursor-pointer ms-1"
                  onClick={() => redirectURL(true, "https://fonts.google.com/")}
                >
                  Google fonts
                </span>
              </Form.Label>
              <Select
                name="json.fontFamily"
                options={fonts}
                value={fonts.find(
                  (option) => option.value === values.json.fontFamily,
                )}
                onChange={(selectedOption) => {
                  setFieldValue("json.fontFamily", selectedOption.value);
                }}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    padding: 5,
                  }),
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md={4} className="mb-3">
              <Form.Label>Tamanho fonte (M) (rem)</Form.Label>
              <Form.Control
                type="number"
                step={"0.01"}
                name="json.h5Size"
                value={values.json.h5Size}
                onChange={handleChange}
                isInvalid={!!errors.json?.h5Size}
                isValid={touched.json?.h5Size && !errors.json?.h5Size}
              />
              <Form.Control.Feedback type="valid"></Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                {errors.json?.h5Size}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md={4} className="mb-3">
              <Form.Label>Tamanho fonte (P) (rem)</Form.Label>
              <Form.Control
                type="number"
                name="json.pSize"
                step={"0.01"}
                value={values.json.pSize}
                onChange={handleChange}
                isInvalid={!!errors.json?.pSize}
                isValid={touched.json?.pSize && !errors.json?.pSize}
              />
              <Form.Control.Feedback type="valid"></Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                {errors.json?.pSize}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
        </>
      )}
      <Row className="mb-3 mx-0">
        <p className="text-start fw-bold mb-2">Identidade</p>
        <Form.Group as={Col} md="6">
          <Form.Label>Logomarca</Form.Label>
          <Card className="mb-3">
            <Card.Body>
              <Form.Control
                type="hidden"
                name="json.logo"
                value={values.json.logo}
                onChange={handleChange}
                isInvalid={!!errors?.json?.logo}
                isValid={touched?.json?.logo && !errors?.json?.logo}
              />
              <div className="imagesUpload">
                <img
                  className={`h-100 img-thumbnail ${!!errors?.json?.logo ? "is-invalid" : ""}`}
                  src={
                    values.json.logo !== "" && values.json.logo !== null
                      ? domainConfig.imageServer +
                      "/evento/" +
                      values.evento_id +
                      "/" +
                      values.json.logo
                      : domainConfig.imageServer + "/empty-background.png"
                  }
                  alt="Imagem preview"
                />
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors?.json?.logo}
                </Form.Control.Feedback>
              </div>
              <DropzoneComponent
                className="mt-3 dropzoneComp"
                type="image"
                handlePreviewSuccess={(fileName, setFieldValueArg, field) => {
                  handlePreviewSuccess(fileName, setFieldValueArg, field);
                  if (fileName) {
                    setFieldValue("json.maskableIcon", fileName);
                    setFieldValue("json.ogImage", fileName);
                  }
                }}
                handlePreviewError={handlePreviewError}
                setFieldValue={setFieldValue}
                folder="evento"
                id={values.evento_id}
                field="json.logo"
              />
              <Form.Group as={Col} className="mt-3">
                <Form.Label>Largura (px)</Form.Label>
                <Form.Control
                  type="text"
                  name="json.logoWidth"
                  value={values.json.logoWidth}
                  onChange={handleChange}
                  isInvalid={!!errors.json?.logoWidth}
                  isValid={touched.json?.logoWidth && !errors.json?.logoWidth}
                />
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors.json?.logoWidth}
                </Form.Control.Feedback>
              </Form.Group>
            </Card.Body>
          </Card>
        </Form.Group>

        {!isSimplifiedCustomization && (
          <Form.Group as={Col} md="6" className="mb-3">
            <div>
              <Form.Label>
                Ícone PWA / Maskable (512x512 PNG)
                <OverlayTrigger
                  overlay={<Tooltip>{pwaMaskableImageTooltip}</Tooltip>}
                >
                  <HelpTooltip icon={faExclamationCircle} />
                </OverlayTrigger>
              </Form.Label>
            </div>
            <Card className="mb-0">
              <Card.Body>
                <Form.Control
                  type="hidden"
                  name="json.maskableIcon"
                  value={values.json.maskableIcon || ""}
                  onChange={handleChange}
                  isInvalid={!!errors?.json?.maskableIcon}
                  isValid={
                    touched?.json?.maskableIcon && !errors?.json?.maskableIcon
                  }
                />
                <div className="imagesUpload">
                  <img
                    className={`h-100 img-thumbnail ${!!errors?.json?.maskableIcon ? "is-invalid" : ""}`}
                    src={
                      values.json.maskableIcon !== "" &&
                        values.json.maskableIcon !== null
                        ? domainConfig.imageServer +
                        "/evento/" +
                        values.evento_id +
                        "/" +
                        values.json.maskableIcon
                        : domainConfig.imageServer + "/empty-background.png"
                    }
                    alt="Imagem preview"
                  />
                  <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                  <Form.Control.Feedback type="invalid">
                    {errors?.json?.maskableIcon}
                  </Form.Control.Feedback>
                </div>
                <DropzoneComponent
                  className="mt-3 dropzoneComp"
                  type="image"
                  handlePreviewSuccess={handlePreviewSuccess}
                  handlePreviewError={handlePreviewError}
                  setFieldValue={setFieldValue}
                  folder="evento"
                  id={values.evento_id}
                  field="json.maskableIcon"
                />
              </Card.Body>
            </Card>
          </Form.Group>
        )}

        {!isSimplifiedCustomization && (
          <Form.Group as={Col} md="6" className="mb-3">
            <div>
              <Form.Label>
                Imagem OG (1200x630)
                <OverlayTrigger
                  overlay={<Tooltip>{ogImageTooltip}</Tooltip>}
                >
                  <HelpTooltip icon={faExclamationCircle} />
                </OverlayTrigger>
              </Form.Label>
            </div>
            <Card className="mb-0">
              <Card.Body>
                <Form.Control
                  type="hidden"
                  name="json.ogImage"
                  value={values.json.ogImage || ""}
                  onChange={handleChange}
                  isInvalid={!!errors?.json?.ogImage}
                  isValid={
                    touched?.json?.ogImage && !errors?.json?.ogImage
                  }
                />
                <div className="imagesUpload">
                  <img
                    className={`h-100 img-thumbnail ${!!errors?.json?.ogImage ? "is-invalid" : ""}`}
                    src={
                      values.json.ogImage !== "" &&
                        values.json.ogImage !== null
                        ? domainConfig.imageServer +
                        "/evento/" +
                        values.evento_id +
                        "/" +
                        values.json.ogImage
                        : domainConfig.imageServer + "/empty-background.png"
                    }
                    alt="Imagem preview"
                  />
                  <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                  <Form.Control.Feedback type="invalid">
                    {errors?.json?.ogImage}
                  </Form.Control.Feedback>
                </div>
                <DropzoneComponent
                  className="mt-3 dropzoneComp"
                  type="image"
                  handlePreviewSuccess={handlePreviewSuccess}
                  handlePreviewError={handlePreviewError}
                  setFieldValue={setFieldValue}
                  folder="evento"
                  id={values.evento_id}
                  field="json.ogImage"
                />
              </Card.Body>
            </Card>
          </Form.Group>
        )}
      </Row>

      {!isSimplifiedCustomization && (
        <MetaTagFields
          titleName="json.metaTagTitle"
          titleValue={values.json.metaTagTitle}
          titleTouched={touched?.json?.metaTagTitle}
          titleError={errors?.json?.metaTagTitle}
          descriptionName="json.metaTagDescription"
          descriptionValue={values.json.metaTagDescription}
          descriptionTouched={touched?.json?.metaTagDescription}
          descriptionError={errors?.json?.metaTagDescription}
          handleChange={handleChange}
        />
      )}

      <Row className="mx-0 mb-3">
        <p className="text-start fw-bold mb-2">Plano de fundo</p>
        <Form.Group as={Col} md="6">
          <Form.Label>
            Tipo
            {values.json.background.type === "color" && (
              <OverlayTrigger
                overlay={
                  <Tooltip>
                    <b>Exemplo: </b>linear-gradient(90deg,rgba(42, 123, 155, 1)
                    0%, rgba(87, 199, 133, 1) 50%, rgba(237, 221, 83, 1) 100%)
                  </Tooltip>
                }
              >
                <span
                  className="badge text-dark bg-light cursor-pointer ms-1"
                  onClick={() => redirectURL(true, "https://cssgradient.io/")}
                >
                  CSS Gradient
                </span>
              </OverlayTrigger>
            )}
          </Form.Label>
          <Form.Select
            name="json.background.type"
            onChange={handleChange}
            value={values.json.background.type}
            isInvalid={!!errors.json?.background?.type}
            isValid={
              touched.json?.background?.type && !errors.json?.background?.type
            }
          >
            <option value={"color"}>Cor</option>
            <option value={"image"}>Imagem</option>
            <option value={"video"}>Vídeo</option>
          </Form.Select>
          <Form.Control.Feedback type="valid"></Form.Control.Feedback>
          <Form.Control.Feedback type="invalid">
            {errors.json?.background?.type}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
      {values.json.background.type !== "color" && (
        <Row className="mb-3 mx-0">
          <Form.Group as={Col} md="6">
            <BackgroundFormComponent
              touched={touched}
              errors={errors}
              values={values}
              setFieldValue={setFieldValue}
              handlePreviewSuccess={handlePreviewSuccess}
              handlePreviewError={handlePreviewError}
              platform={dataTable.platform}
            ></BackgroundFormComponent>
          </Form.Group>
        </Row>
      )}
      {values.json.background.type === "color" && (
        <Row
          className="mx-0 mb-3"
          data-error-path="json.background.color,json.baseColorText,json.transparency,json.primaryColor,json.primaryColorText,json.bsBorderColor,json.boxShadow"
        >
          <Col
            sm={6}
            className={
              errors?.json?.background?.color ||
                errors?.json?.baseColorText ||
                errors?.json?.transparency ||
                errors?.json?.primaryColor ||
                errors?.json?.primaryColorText ||
                errors?.json?.bsBorderColor ||
                errors?.json?.boxShadow
                ? "mb-3 is-invalid"
                : "mb-3"
            }
          >
            <Row>
              <div
                className={`d-flex justify-content-start align-items-center ${errors?.json?.background?.color ? "is-invalid" : ""}`}
              >
                <PopoverPicker
                  color={props.backgroundColor}
                  onChangeX={(e) => {
                    setFieldValue("json.background.color", e);
                    const newBaseColorText = values.json.layout.type === 1
                      ? getContrastColor(e)
                      : getContrastColor(values.json.transparency, e);
                    if (newBaseColorText) {
                      setFieldValue("json.baseColorText", newBaseColorText);
                    }
                    setProps((prevState) => ({
                      ...prevState,
                      backgroundColor: e,
                      ...(newBaseColorText ? { baseColorText: newBaseColorText } : {}),
                    }));
                  }}
                  classes={`me-1 picker ${errors?.json?.background?.color ? "is-invalid" : ""}`}
                />
              </div>
              <Form.Control.Feedback type="invalid">
                {getFirstError(
                  errors?.json?.background?.color, // Add more variables as needed
                )}
              </Form.Control.Feedback>
            </Row>
          </Col>
        </Row>
      )}

      {!isSimplifiedCustomization && (
        <>
          <Row className="mx-0 mb-3">
            <p className="text-start fw-bold mb-2">Cores</p>
            <Col
              sm={6}
              className={
                errors?.json?.background?.color ||
                  errors?.json?.baseColorText ||
                  errors?.json?.transparency ||
                  errors?.json?.primaryColor ||
                  errors?.json?.primaryColorText ||
                  errors?.json?.bsBorderColor ||
                  errors?.json?.boxShadow
                  ? "mb-3 is-invalid"
                  : "mb-3"
              }
            >
              <Form.Label>Cards</Form.Label>
              {values.json.layout.type === 2 && <Row className="mb-2">
                <div
                  className={`d-flex justify-content-start align-items-center ${errors?.json?.transparency ? "is-invalid" : ""}`}
                >
                  <PopoverPicker
                    color={props.transparency}
                    onChangeX={(e) => {
                      setFieldValue("json.transparency", e);
                      setProps((prevState) => ({
                        ...prevState,
                        transparency: e,
                      }));
                    }}
                    classes={`me-1 picker ${errors?.json?.transparency ? "is-invalid" : ""}`}
                  />
                  <Form.Label className="mb-0 ms-2">Cor de fundo</Form.Label>
                </div>
                <Form.Control.Feedback type="invalid">
                  {getFirstError(errors?.json?.transparency)}
                </Form.Control.Feedback>
              </Row>}

              <Row className="mb-2">
                <div
                  className={`d-flex justify-content-start align-items-center ${errors?.json?.baseColorText ? "is-invalid" : ""}`}
                >
                  <PopoverPicker
                    color={props.baseColorText}
                    onChangeX={(e) => {
                      setFieldValue("json.baseColorText", e);
                      setProps((prevState) => ({
                        ...prevState,
                        baseColorText: e,
                      }));
                    }}
                    classes={`me-1 picker ${errors?.json?.baseColorText ? "is-invalid" : ""}`}
                  />
                  <Form.Label className="mb-0 ms-2">Cor do texto</Form.Label>
                </div>
                <Form.Control.Feedback type="invalid">
                  {getFirstError(errors?.json?.baseColorText)}
                </Form.Control.Feedback>
              </Row>
              {values.json.layout.type === 2 && <Row className="mb-2">
                <div
                  className={`d-flex justify-content-start align-items-center ${errors?.json?.boxShadow ? "is-invalid" : ""}`}
                >
                  <PopoverPicker
                    color={props.boxShadow}
                    onChangeX={(e) => {
                      setFieldValue("json.boxShadow", e);
                      setProps((prevState) => ({
                        ...prevState,
                        boxShadow: e,
                      }));
                    }}
                    classes={`me-1 picker ${errors?.json?.boxShadow ? "is-invalid" : ""}`}
                  />
                  <Form.Label className="mb-0 ms-2">Sombra</Form.Label>
                </div>
                <Form.Control.Feedback type="invalid">
                  {getFirstError(errors?.json?.boxShadow)}
                </Form.Control.Feedback>
              </Row>}
              <Row className="mb-2">
                <div
                  className={`d-flex justify-content-start align-items-center ${errors?.json?.bsBorderColor ? "is-invalid" : ""}`}
                >
                  <PopoverPicker
                    color={props.bsBorderColor}
                    onChangeX={(e) => {
                      setFieldValue("json.bsBorderColor", e);
                      setProps((prevState) => ({
                        ...prevState,
                        bsBorderColor: e,
                      }));
                    }}
                    classes={`me-1 picker ${errors?.json?.bsBorderColor ? "is-invalid" : ""}`}
                  />
                  <Form.Label className="mb-0 ms-2">Bordas</Form.Label>
                </div>
                <Form.Control.Feedback type="invalid">
                  {getFirstError(errors?.json?.bsBorderColor)}
                </Form.Control.Feedback>
              </Row>
            </Col>
            <Col
              sm={6}
              className={
                errors?.json?.background?.color ||
                  errors?.json?.baseColorText ||
                  errors?.json?.transparency ||
                  errors?.json?.primaryColor ||
                  errors?.json?.primaryColorText ||
                  errors?.json?.bsBorderColor ||
                  errors?.json?.boxShadow
                  ? "mb-3 is-invalid"
                  : "mb-3"
              }
            >
              <Row className="mb-2">
                <Form.Label>Botões e elementos destacáveis</Form.Label>
                <div
                  className={`d-flex justify-content-start align-items-center ${errors?.json?.primaryColor ? "is-invalid" : ""}`}
                >
                  <PopoverPicker
                    color={props.primaryColor}
                    onChangeX={(e) => {
                      setFieldValue("json.primaryColor", e);
                      setProps((prevState) => ({
                        ...prevState,
                        primaryColor: e,
                      }));
                    }}
                    classes={`me-1 picker ${errors?.json?.primaryColor ? "is-invalid" : ""}`}
                  />
                  <Form.Label className="mb-0 ms-2">Cor de fundo</Form.Label>
                </div>
                <Form.Control.Feedback type="invalid">
                  {getFirstError(errors?.json?.primaryColor)}
                </Form.Control.Feedback>
              </Row>

              <Row className="mb-2">
                <div
                  className={`d-flex justify-content-start align-items-center ${errors?.json?.primaryColorText ? "is-invalid" : ""}`}
                >
                  <PopoverPicker
                    color={props.primaryColorText}
                    onChangeX={(e) => {
                      setFieldValue("json.primaryColorText", e);
                      setProps((prevState) => ({
                        ...prevState,
                        primaryColorText: e,
                      }));
                    }}
                    classes={`me-1 picker ${errors?.json?.primaryColorText ? "is-invalid" : ""}`}
                  />
                  <Form.Label className="mb-0 ms-2">Cor do texto</Form.Label>
                </div>
                <Form.Control.Feedback type="invalid">
                  {getFirstError(errors?.json?.primaryColorText)}
                </Form.Control.Feedback>
              </Row>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export const AppApplications = ({
  setModal,
  applications,
  setDataAplicativo,
  setApplications,
  values,
  touched,
  errors,
  handleChange,
  setFieldValue,
}) => {
  return (
    <>
      <Form.Group as={Col} className="textHeaderAplicativo mb-3 mx-2">
        <h5 className="card-title mb-0">Gerenciamento de aplicativos</h5>
      </Form.Group>
      <Row className="my-3 mx-0">
        {applications &&
          applications.map((valueX, index) => {
            const appImage = valueX.imagem || valueX.image;

            return (
              <Col
                className="mb-3"
                key={"card" + index}
                lg="4"
                md="4"
                sm="6"
                xl="3"
              >
                <Card className="mainCardApps mb-0">
                  <div className="p-3 d-flex flex-column h-100">
                    {appImage && (
                      <Card.Img
                        className="px-3 pt-2"
                        src={`${domainConfig.imageServer}/flex/painel/${appImage}`}
                        alt={valueX.nome || "Aplicativo"}
                      />
                    )}
                    <h6 className="mb-0">{valueX.nome}</h6>
                    <hr></hr>
                    <h5>
                      Título:{" "}
                      <span className="opacity-75">{valueX.titulo}</span>
                    </h5>
                    <div>
                      <Badge variant="primary" className="text-black">
                        {valueX.version === "toUpdate"
                          ? "Atualizado"
                          : 'v.' + valueX.version}
                      </Badge>
                    </div>
                    <div className="mt-auto text-center">
                      <div className="mt-3">
                        {valueX.currentVersion &&
                          valueX.version != valueX.currentVersion &&
                          valueX.version !== "toUpdate" && (
                            <Button
                              variant="primary"
                              className="btn-sm mt-2 me-2"
                              onClick={(e) =>
                                updateCustomizationVersion(
                                  e,
                                  setApplications,
                                  valueX,
                                )
                              }
                            >
                              Atualizar versão
                            </Button>
                          )}
                        <Button
                          variant="danger"
                          className="btn-sm mt-2"
                          onClick={(e) =>
                            removeCustomizationFromEvent(
                              e,
                              setApplications,
                              valueX.customizacao_id,
                            )
                          }
                        >
                          Remover
                        </Button>
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
            );
          })}
        <Col className="vertically-centered mb-3" lg="4" md="4" sm="6" xl="3">
          <div
            className="addMainCard"
            onClick={() => {
              setDataAplicativo(false);
              setModal((prevState) => ({
                ...prevState,
                showModalAplicativos: true,
              }));
            }}
          >
            <FontAwesomeIcon icon={faPlus} />
          </div>
        </Col>
      </Row>
      <hr></hr>
      {applications.length > 1 && (
        <>
          <Row className="mx-0 mb-3">
            <p className="text-start fw-bold mb-2">
              <FontAwesomeIcon
                icon={faTabletScreenButton}
                className="me-1"
              />Tela de seleção de aplicativos
              <OverlayTrigger
                overlay={
                  <Tooltip>
                    Em caso de evento com mais de 1 aplicativo associado esta
                    tela ficará como intermediador entre o registro e os
                    aplicativos
                  </Tooltip>
                }
              >
                <HelpTooltip icon={faExclamationCircle} />
              </OverlayTrigger>
            </p>
            <Form.Group className="mb-3" as={Col} sm="12">
              <Form.Label>Título</Form.Label>
              <Form.Control
                type="text"
                name="json.applications.title.value"
                value={values.json.applications?.title?.value}
                onChange={(e) => {
                  if (e.target.value === "") {
                    setFieldValue("json.applications.title.status", false);
                  } else {
                    setFieldValue("json.applications.title.status", true);
                  }
                  setFieldValue(
                    "json.applications.title.value",
                    e.target.value,
                  );
                }}
                isInvalid={!!errors?.json?.applications?.title.value}
                isValid={
                  touched?.json?.applications?.title.value &&
                  !errors?.json?.applications?.title.value
                }
              />
              <Form.Control.Feedback type="valid"></Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                {errors.json?.applications?.title.value}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" as={Col} sm="12">
              <Form.Label>Descrição</Form.Label>
              <Form.Control
                name="json.applications.description.value"
                as="textarea"
                value={values.json.applications?.description?.value}
                onChange={(e) => {
                  if (e.target.value === "") {
                    setFieldValue(
                      "json.applications.description.status",
                      false,
                    );
                  } else {
                    setFieldValue("json.applications.description.status", true);
                  }
                  setFieldValue(
                    "json.applications.description.value",
                    e.target.value,
                  );
                }}
                isInvalid={!!errors?.json?.applications?.description.value}
                isValid={
                  touched?.json?.applications?.description.value &&
                  !errors?.json?.applications?.description.value
                }
              />
              <Form.Control.Feedback type="valid"></Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                {errors.json?.applications?.description.value}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" as={Col} sm="12">
              <Form.Check
                checked={values.json.applications.reset ? true : false}
                type="checkbox"
                name="json.applications.reset"
                label="Habilitar botão de voltar para tela de registro"
                onChange={(e) => {
                  setFieldValue(
                    "json.applications.reset",
                    values.json.applications.reset ? false : true,
                  );
                }}
              />
            </Form.Group>
          </Row>
        </>
      )}
      <Row className="mx-0">
        <p className="text-start fw-bold mb-2">
          <FontAwesomeIcon
            icon={faTabletScreenButton}
            className="me-1"
          />Tela de registro
        </p>
        <Form.Group className="mb-3" as={Col} sm="12">
          <Form.Label>Título</Form.Label>
          <Form.Control
            as="textarea"
            name="json.form.title.value"
            value={values.json.form.title.value}
            onChange={(e) => {
              if (e.target.value === "") {
                setFieldValue("json.form.title.status", false);
              } else {
                setFieldValue("json.form.title.status", true);
              }
              setFieldValue("json.form.title.value", e.target.value);
            }}
            isInvalid={!!errors?.json?.form?.title?.value}
            isValid={
              touched?.json?.form?.title?.value &&
              !errors?.json?.form?.title?.value
            }
          />
          <Form.Control.Feedback type="valid"></Form.Control.Feedback>
          <Form.Control.Feedback type="invalid">
            {errors.json?.form?.title?.value}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3" as={Col} sm="12">
          <Form.Label>Descrição</Form.Label>
          <Form.Control
            name="json.form.description.value"
            as="textarea"
            value={values.json.form.description.value}
            onChange={(e) => {
              if (e.target.value === "") {
                setFieldValue("json.form.description.status", false);
              } else {
                setFieldValue("json.form.description.status", true);
              }
              setFieldValue("json.form.description.value", e.target.value);
            }}
            isInvalid={!!errors?.json?.form?.description?.value}
            isValid={
              touched?.json?.form?.description?.value &&
              !errors?.json?.form?.description?.value
            }
          />
          <Form.Control.Feedback type="valid"></Form.Control.Feedback>
          <Form.Control.Feedback type="invalid">
            {errors.json?.form?.description?.value}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} sm="12" className="mb-3">
          <Form.Label>Texto do botão</Form.Label>
          <Form.Control
            name="json.form.buttonText"
            value={values.json.form.buttonText}
            onChange={handleChange}
            isInvalid={!!errors?.json?.form?.buttonText}
            isValid={
              touched?.json?.form?.buttonText && !errors?.json?.form?.buttonText
            }
          />
          <Form.Control.Feedback type="valid"></Form.Control.Feedback>
          <Form.Control.Feedback type="invalid">
            {errors?.json?.form?.buttonText}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
      <Row className="mb-3 mx-0">
        <Form.Group className="mb-3">
          <Form.Check
            checked={values.json.end.reset ? true : false}
            type="checkbox"
            name="json.end.reset"
            label="Habilitar botão de voltar para tela de registro"
            onChange={(e) => {
              setFieldValue(
                "json.end.reset",
                values.json.end.reset ? false : true,
              );
            }}
          />
          <Form.Check
            checked={values.json.end.showQRCode ? true : false}
            type="checkbox"
            name="json.end.showQRCode"
            label="Mostrar código QR do participante"
            onChange={(e) => {
              setFieldValue(
                "json.end.showQRCode",
                values.json.showQRCode ? false : true,
              );
            }}
          />
          <Form.Check
            checked={values.json.end.showUserData ? true : false}
            type="checkbox"
            name="json.end.showUserData"
            label="Mostrar dados de registro do participante"
            onChange={(e) => {
              setFieldValue(
                "json.end.showUserData",
                values.json.end.showUserData ? false : true,
              );
            }}
          />
        </Form.Group>
      </Row>
      {applications.length === 0 && (
        <Row className="mx-0 mb-3">
          <p className="text-start fw-bold mb-2">
            <FontAwesomeIcon
              icon={faTabletScreenButton}
              className="me-1"
            />Tela pós-registro
            <OverlayTrigger
              overlay={
                <Tooltip>
                  Se o evento não tiver aplicativos associados, após o
                  registro o usuário será redirecionado para essa tela
                </Tooltip>
              }
            >
              <HelpTooltip icon={faExclamationCircle} />
            </OverlayTrigger>
          </p>
          <Form.Group className="mb-3" as={Col} sm="12">
            <Form.Label>Título</Form.Label>
            <Form.Control
              type="text"
              name="json.end.title.value"
              value={values.json.end.title.value}
              onChange={(e) => {
                if (e.target.value === "") {
                  setFieldValue("json.end.title.status", false);
                } else {
                  setFieldValue("json.end.title.status", true);
                }
                setFieldValue("json.end.title.value", e.target.value);
              }}
              isInvalid={!!errors?.json?.end?.title.value}
              isValid={
                touched?.json?.end?.title.value &&
                !errors?.json?.end?.title.value
              }
            />
            <Form.Control.Feedback type="valid"></Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              {errors.json?.end?.title.value}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3" as={Col} sm="12">
            <Form.Label>Descrição</Form.Label>
            <Form.Control
              name="json.end.description.value"
              as="textarea"
              value={values.json.end.description.value}
              onChange={(e) => {
                if (e.target.value === "") {
                  setFieldValue("json.end.description.status", false);
                } else {
                  setFieldValue("json.end.description.status", true);
                }
                setFieldValue("json.end.description.value", e.target.value);
              }}
              isInvalid={!!errors?.json?.end?.description.value}
              isValid={
                touched?.json?.end?.description.value &&
                !errors?.json?.end?.description.value
              }
            />
            <Form.Control.Feedback type="valid"></Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              {errors.json?.end?.description.value}
            </Form.Control.Feedback>
          </Form.Group>
        </Row>
      )}


      <Row className="mx-0 mb-3">
        <p className="text-start fw-bold mb-2">
          <FontAwesomeIcon icon={faTabletScreenButton} className="me-1" />Tela de registro encerrado

          <OverlayTrigger
            overlay={
              <Tooltip>
                O usuário será redirecionado para essa tela em caso se o status
                da inscrição for "Encerrado"{" "}
              </Tooltip>
            }
          >
            <HelpTooltip icon={faExclamationCircle} />
          </OverlayTrigger>
        </p>
        <Form.Group className="mb-3" as={Col} sm="12">
          <Form.Label>Título</Form.Label>
          <Form.Control
            as="textarea"
            name="json.form.disableFormTitle"
            value={values.json.form.disableFormTitle}
            onChange={handleChange}
            isInvalid={!!errors?.json?.form?.disableFormTitle}
            isValid={
              touched?.json?.form?.disableFormTitle &&
              !errors?.json?.form?.disableFormTitle
            }
          />
          <Form.Control.Feedback type="valid"></Form.Control.Feedback>
          <Form.Control.Feedback type="invalid">
            {errors?.json?.form?.disableFormTitle}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm="12">
          <Form.Label>Descrição</Form.Label>
          <Form.Control
            as="textarea"
            name="json.form.disableDescription"
            value={values.json.form.disableDescription}
            onChange={handleChange}
            isInvalid={!!errors?.json?.form?.disableDescription}
            isValid={
              touched?.json?.form?.disableDescription &&
              !errors?.json?.form?.disableDescription
            }
          />
          <Form.Control.Feedback type="valid"></Form.Control.Feedback>
          <Form.Control.Feedback type="invalid">
            {errors?.json?.form?.disableDescription}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
    </>
  );
};

export const SideButtonPanel = ({
  dataTable,
  isSubmitting,
  onSubmit,
  setDataTableUpdate,
  hasUnsavedChanges,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [previewMode, setPreviewMode] = useState("participant");
  const [previewDialogType, setPreviewDialogType] = useState(null);
  const previewUrls = getPlatform1ShareUrls(dataTable);
  const previewUrl = previewMode === "participant"
    ? previewUrls.participant
    : previewUrls.presenter;

  const handleSave = (e) => {
    e.preventDefault();
    onSubmit(false);
  };

  const handleApply = (e) => {
    e.preventDefault();
    onSubmit(true);
    setDataTableUpdate((prevCount) => prevCount + 1);
  };

  const handlePreviewButtonClick = () => {
    if (isOpen) {
      setIsOpen(false);
      return;
    }

    if (!dataTable?.token) {
      setPreviewDialogType("event-not-saved");
      return;
    }

    if (!previewUrl) {
      setPreviewDialogType("preview-link-unavailable");
      return;
    }

    if (hasUnsavedChanges) {
      setPreviewDialogType("unsaved-changes");
      return;
    }

    setIsOpen(true);
  };

  const confirmOpenSavedPreview = () => {
    setPreviewDialogType(null);
    setIsOpen(true);
  };

  useEffect(() => {
    let frameId = null;

    const updateModalScrollbarWidth = () => {
      frameId = null;
      const modalBodies = Array.from(
        document.querySelectorAll(".modal.show .modal-body"),
      );
      const activeModalBody = modalBodies.reverse().find((modalBody) => (
        modalBody.offsetParent !== null
      ));
      const scrollbarWidth = activeModalBody
        ? Math.max(activeModalBody.offsetWidth - activeModalBody.clientWidth, 0)
        : 0;

      document.documentElement.style.setProperty(
        "--side-panel-modal-scrollbar-width",
        `${scrollbarWidth}px`,
      );
    };

    const scheduleUpdate = () => {
      if (frameId !== null) cancelAnimationFrame(frameId);
      frameId = requestAnimationFrame(updateModalScrollbarWidth);
    };
    const observer = new MutationObserver(scheduleUpdate);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"],
    });
    window.addEventListener("resize", scheduleUpdate);
    scheduleUpdate();

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", scheduleUpdate);
      if (frameId !== null) cancelAnimationFrame(frameId);
      document.documentElement.style.removeProperty(
        "--side-panel-modal-scrollbar-width",
      );
    };
  }, []);

  return (
    <>
      <div className={"side-panel-button side-panel-button-mode02 " + (isOpen ? "" : "open")}>
        <OverlayTrigger placement="left" overlay={<Tooltip>Prévia</Tooltip>}>
          <Button
            id="btn-preview-layout"
            type="button"
            variant="primary"
            className="my-1"
            onClick={handlePreviewButtonClick}
          >
            <FontAwesomeIcon icon={faPalette} size="lg" />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger placement="left" overlay={<Tooltip>Salvar e aplicar</Tooltip>}>
          <Button
            className="my-1"
            variant="primary"
            type="button"
            onClick={handleApply}
            disabled={isSubmitting}
          >
            <FontAwesomeIcon icon={faSave} size="lg" />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger placement="left" overlay={<Tooltip>Salvar e finalizar</Tooltip>}>
          <Button
            className="my-1"
            variant="primary"
            type="button"
            onClick={handleSave}
            disabled={isSubmitting}
          >
            <FontAwesomeIcon icon={faCheck} size="lg" />
          </Button>
        </OverlayTrigger>
      </div>
      <div className={"side-panel side-panel-mode02 " + (isOpen ? "open" : "")}>
        <div className="modal-header px-0 pb-2 pt-0 d-flex justify-content-between align-items-center">
          <div className="btn-group" role="group" aria-label="Modo da pré-visualização">
            <button
              type="button"
              className={"btn btn-sm " + (previewMode === "participant" ? "btn-primary" : "btn-outline-primary")}
              onClick={() => setPreviewMode("participant")}
            >
              Participante
            </button>
            <button
              type="button"
              className={"btn btn-sm " + (previewMode === "presenter" ? "btn-primary" : "btn-outline-primary")}
              onClick={() => setPreviewMode("presenter")}
              disabled={!previewUrls.presenter}
            >
              Modo apresentador
            </button>
          </div>
          <button
            type="button"
            onClick={() => setIsOpen(false)}
            className="btn-close ms-2"
            aria-label="Fechar"
          ></button>
        </div>
        {isOpen && previewUrl && (
          <EventWebappPreview
            src={previewUrl}
            title={previewMode === "participant"
              ? "Pré-visualização do participante"
              : "Pré-visualização do modo apresentador"}
          />
        )}
        <Modal
          show={Boolean(previewDialogType)}
          onHide={() => setPreviewDialogType(null)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {previewDialogType === "unsaved-changes"
                ? "Alterações não salvas"
                : previewDialogType === "event-not-saved"
                  ? "Evento não salvo"
                  : "Pré-visualização indisponível"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {previewDialogType === "unsaved-changes"
              ? "A pré-visualização mostrará a última versão salva do evento; suas alterações atuais não serão incluídas. Deseja continuar?"
              : previewDialogType === "event-not-saved"
                ? "Salve o evento para gerar o link e abrir a pré-visualização."
                : "O link do webapp não está disponível para este evento."}
          </Modal.Body>
          <Modal.Footer>
            {previewDialogType === "unsaved-changes" ? (
              <>
                <Button
                  type="button"
                  variant="secondary"
                  onClick={() => setPreviewDialogType(null)}
                >
                  Voltar
                </Button>
                <Button
                  type="button"
                  variant="primary"
                  onClick={confirmOpenSavedPreview}
                >
                  Abrir versão salva
                </Button>
              </>
            ) : (
              <Button
                type="button"
                variant="secondary"
                onClick={() => setPreviewDialogType(null)}
              >
                Fechar
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
export function updateCustomizationVersion(e, setApplications, props) {
  e.preventDefault();
  e.stopPropagation();
  setApplications((prevData) => {
    const currentIndex = prevData.findIndex(
      (data) => data.customizacao_id === props.customizacao_id,
    );
    if (currentIndex !== -1) {
      const newData = [
        ...prevData.slice(0, currentIndex),
        { ...prevData[currentIndex], version: "toUpdate" },
        ...prevData.slice(currentIndex + 1),
      ];
      return newData;
    }
    return prevData;
  });
}

export function removeCustomizationFromEvent(
  e,
  setApplications,
  customizacao_id,
) {
  e.preventDefault();
  e.stopPropagation();
  setApplications((prevData) => {
    const indexToRemove = prevData.findIndex(
      (field) => field.customizacao_id === customizacao_id,
    );
    const newData = [...prevData];
    newData.splice(indexToRemove, 1);
    return newData;
  });
}

export const AplicativosType = ({
  applications,
  setApplications,
  dataAplicativo,
  setDataAplicativo,
  modal,
  setModal,
  aplicativos,
}) => {
  function addCustomization(values) {
    let newObject = {
      customizacao_id: values.customizacao_id,
      aplicativo_id: values.aplicativo_id,
      titulo: values.titulo,
      version: values.version,
      imagem: values.imagem || dataAplicativo.imagem,
    };
    setApplications((prevData) => {
      const duplicatedCustomization = prevData.some(
        (data) => data.customizacao_id === newObject.customizacao_id,
      );

      if (duplicatedCustomization) {
        return prevData;
      }

      newObject.nome = dataAplicativo.nome;
      let newData = [...prevData, newObject];
      return newData;
    });
    setModal((prevState) => ({
      ...prevState,
      showModalAplicativos: false,
    }));
  }

  if (!dataAplicativo) {
    return (
      <Modal
        show={modal.showModalAplicativos}
        size={"lg"}
        onHide={(e) => {
          setModal((prevState) => ({
            ...prevState,
            showModalAplicativos: false,
          }));
        }}
        fullscreen={"sm-down"}
        centered
        backdrop
        scrollable
      >
        <Modal.Header closeButton>Selecione um aplicativo</Modal.Header>
        <Modal.Body>
          <ApplicationsList
            aplicativos={aplicativos}
            setDataAplicativo={setDataAplicativo}
            addCustomization={addCustomization}
          />
        </Modal.Body>
      </Modal>
    );
  } else {
    return (
      <Modal
        show={modal.showModalAplicativos}
        size={"lg"}
        onHide={(e) => {
          setModal((prevState) => ({
            ...prevState,
            showModalAplicativos: false,
          }));
        }}
        fullscreen={"sm-down"}
        centered
        backdrop
        scrollable
      >
        <Modal.Header closeButton>Escolha uma customização</Modal.Header>
        <Modal.Body>
          <CustomizationsList
            dataAplicativo={dataAplicativo}
            applications={applications}
            addCustomization={addCustomization}
          ></CustomizationsList>
        </Modal.Body>
      </Modal>
    );
  }
};

export const CustomizationsList = ({
  dataAplicativo,
  applications,
  addCustomization,
}) => {
  const [customizations, setCustomizations] = useState(false);
  const userState = useAuth();
  const isAdmin = Number(userState?.tipo) === 1;
  const [customizationScope, setCustomizationScope] = useState("mine");
  const shouldLoadAllCustomizations = isAdmin && customizationScope === "all";

  const addedCustomizationIds = new Set(
    (applications || []).map((application) => application.customizacao_id),
  );

  const handleCustomizationScopeChange = (scope) => {
    setCustomizations(false);
    setCustomizationScope(scope);
  };

  useEffect(() => {
    const scopeQuery = shouldLoadAllCustomizations ? "&all_users=true" : "";
    axios
      .get(
        `/api/customization?aplicativo_id=${dataAplicativo.aplicativo_id}&rascunho=false${scopeQuery}`,
      )
      .then(function (response) {
        var data = response.data.message;
        data.forEach(function callback(value, index) {
          value.json = safeJsonParse(value.json);
          value.data_edicao = convertDateToDisplay(value.data_edicao, true);
        });
        setCustomizations(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [dataAplicativo.aplicativo_id, shouldLoadAllCustomizations]);

  if (!customizations) {
    return (
      <div className="py-5">
        <Loader></Loader>
      </div>
    );
  }

  return (
    <>
      {isAdmin && (
        <div className="d-flex justify-content-end mb-3">
          <Dropdown>
            <Dropdown.Toggle className="btn-primary text-nowrap">
              {customizationScope === "all"
                ? "Customizações de todos os usuários"
                : "Minhas customizações"}
            </Dropdown.Toggle>
            <Dropdown.Menu align="end">
              <Dropdown.Item
                className={customizationScope === "mine" ? "active" : ""}
                onClick={() => handleCustomizationScopeChange("mine")}
              >
                Minhas customizações
              </Dropdown.Item>
              <Dropdown.Item
                className={customizationScope === "all" ? "active" : ""}
                onClick={() => handleCustomizationScopeChange("all")}
              >
                Customizações de todos os usuários
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      )}
      <div className="list-group">
        {customizations.length > 0 ? (
          customizations.map((value, index) => {
            const isAdded = addedCustomizationIds.has(value.customizacao_id);

            return (
              <div
                key={"gameMode" + index}
                className={`list-group-item list-group-item-action mb-2 ${isAdded ? "disabled" : ""}`}
                aria-current="true"
                aria-disabled={isAdded}
                onClick={isAdded ? undefined : () => addCustomization(value)}
                style={{ cursor: isAdded ? "not-allowed" : "pointer" }}
              >
                <div className="d-flex w-100 justify-content-between">
                  <h5 className="mb-1">
                    {" "}
                    {value.titulo === "" ? (
                      <span className="text-muted">Sem título</span>
                    ) : (
                      value.titulo
                    )}
                  </h5>
                  <small>{value.data_criacao}</small>
                </div>
                {value.titulo === "" && (
                  <Badge bg={"light"} className="text-dark me-2">
                    Rascunho
                  </Badge>
                )}
                <Badge bg={"light"} className="text-dark me-2">
                  v.{value.version}
                </Badge>
                {isAdded && (
                  <Badge bg={"primary"} className="text-black me-2">
                    Adicionado
                  </Badge>
                )}
              </div>
            );
          })
        ) : (
          <h5 className="py-5 text-center opacity-50">
            Nenhuma customização encontrada
          </h5>
        )}
      </div>
    </>
  );
};

export const CustomizationModal = ({
  showCustomizationModal,
  setShowCustomizationModal,
  props,
  notyf,
}) => {
  const [selectedCustomization, setSelectedCustomization] = useState(null);
  const [selectedApp, setSelectedApp] = useState(null);
  const [showModalOptions, setShowModalOptions] = useState(false);

  const handleSelectCustomization = (customization) => {
    setSelectedCustomization(customization.customizacao_id);
    setSelectedApp(customization);
    setShowModalOptions(true);
  };

  const handleSelectModal = (modalId) => {
    // Redirect to presenter mode with the selected customization and modal
    redirectURL(
      true,
      domainConfig.aplicativos +
      "/?token=" +
      props.token +
      "&presenter=" +
      props.codigo_presenter +
      "&customizacao_id=" +
      selectedCustomization +
      "&modal=" +
      modalId,
    );
  };

  const handleBack = () => {
    setShowModalOptions(false);
    setSelectedCustomization(null);
    setSelectedApp(null);
  };

  const resetModal = () => {
    setSelectedCustomization(null);
    setSelectedApp(null);
    setShowModalOptions(false);
    setShowCustomizationModal(false);
  };

  // Get customizations from the event's app_details
  const customizations = props.app_details || [];

  return (
    <Modal
      show={showCustomizationModal}
      size={"md"}
      fullscreen={"sm-down"}
      onHide={resetModal}
      centered
      backdrop
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Selecionar tela do modo de apresentação</Modal.Title></Modal.Header>
      <Modal.Body>
        <Form.Group>
          {!showModalOptions ? (
            <>
              <Form.Label>Selecione uma customização para continuar</Form.Label>
              {customizations.length > 0 ? (
                <div className="list-group">
                  {customizations.map((customization, index) => (
                    <div
                      key={"customization" + index}
                      className="list-group-item list-group-item-action mb-2 py-2 px-2"
                      aria-current="true"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSelectCustomization(customization)}
                    >
                      <div className="d-flex w-100 justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          {customization.imagem && (
                            <img
                              src={`${domainConfig.imageServer}/flex/painel/${customization.imagem}`}
                              alt={customization.titulo || "Customização"}
                              style={{
                                width: "60px",
                                height: "60px",
                                objectFit: "cover",
                                borderRadius: "5px",
                                marginRight: "15px",
                              }}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          )}
                          <div>
                            <h5 className="mb-0">
                              {customization.titulo === "" ||
                                !customization.titulo ? (
                                <span className="text-muted">Sem título</span>
                              ) : (
                                customization.titulo
                              )}
                            </h5>
                            <small className="text-muted">
                              {customization.nomeAplicativo}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-4">
                  <p className="text-muted">
                    Nenhuma customização associada a este evento
                  </p>
                </div>
              )}
            </>
          ) : (
            <>
              <Form.Label>Selecione uma opção</Form.Label>
              {selectedApp && appModals[selectedApp.aplicativo_id] ? (
                <div className="list-group">
                  {appModals[selectedApp.aplicativo_id].map((modal, index) => (
                    <div
                      key={"modal" + index}
                      className="list-group-item list-group-item-action mb-2 py-3 px-3"
                      aria-current="true"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSelectModal(modal.id)}
                    >
                      <div className="d-flex w-100 align-items-center">
                        <div className="me-3">
                          <FontAwesomeIcon
                            icon={modal.icon}
                            size="2x"
                            className="text-primary"
                          />
                        </div>
                        <div>
                          <h5 className="mb-0">{modal.name}</h5>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-4">
                  <p className="text-muted">
                    Nenhum modal disponível para este aplicativo
                  </p>
                </div>
              )}
            </>
          )}
        </Form.Group>
      </Modal.Body>
      {showModalOptions && (
        <Modal.Footer>
          <Button variant="secondary" onClick={handleBack}>
            Voltar
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};
